export default __webpack_public_path__ + "static/media/lgoBl.fc4a5859.png";